import {
    LoginErrorResponse,
    ExploitLogoutErrorResponse,
} from './_private/Types';

export class LoginError extends Error {
    constructor(public errorResponse: LoginErrorResponse) {
        super();
        // we need this if we wanna correct instanceof behaviour
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class ExploitLogoutError extends Error {
    // eslint-disable-next-line sonarjs/no-identical-functions
    constructor(public errorResponse: ExploitLogoutErrorResponse) {
        super();
        // we need this if we wanna correct instanceof behaviour
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
